module.exports = __webpack_public_path__ + "img/shopee_logo.53fbd4ff.png";